import styled from "styled-components";

export const LinkTitle = styled.p`
  white-space: nowrap;
  position: absolute;
  font-size: 22px;
  font-family: "noto-sans", sans-serif;
`;
